module.exports = __webpack_public_path__ + "static/media/error.ad1bf0dd.svg";